import { parsePhoneNumberWithError } from "libphonenumber-js";

export function formatPhoneForDisplay(phoneNumber?: string): string {
  if (!phoneNumber?.trim()) {
    return "";
  }

  try {
    const parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber);

    return parsedPhoneNumber.country === "US"
      ? parsedPhoneNumber.formatNational()
      : parsedPhoneNumber.formatInternational();
  } catch {
    return phoneNumber;
  }
}
